import { Box, Card, CardContent, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Page from '../../components-ui/page';
import BieuDoDangKy from './chart/BieuDoDangKy';
import BieuDoPhanPhoiDiem from './chart/BieuDoPhanPhoiDiem';
import BieuDoTuyenSinh from './chart/BieuDoTuyenSinh';
import BieuDoHocKy from './chart/BieuDoHocKy';
export interface RegistrationData {
    month: string;
    registrations: number;
}

export interface GradeDistributionData {
    grade: string;
    count: number;
}

export interface AdmissionBatchData {
    batch: string; // Ví dụ: "2023-2024"
    studentCount: number;
}

export interface SemesterData {
    semester: string; // Ví dụ: "Học kỳ 1, Năm học 2023-2024"
    averageGrade: number;
}
const HomePage = () => {
    // Dữ liệu mẫu
    // Dữ liệu mẫu
    const registrationData: RegistrationData[] = [
        { month: 'Thang 1', registrations: 120 },
        { month: 'Thang 2', registrations: 150 },
        { month: 'Thang 3', registrations: 180 },
        { month: 'Thang 4', registrations: 200 },
        { month: 'Thang 5', registrations: 220 }
    ];

    const gradeDistributionData: GradeDistributionData[] = [
        { grade: 'A', count: 50 },
        { grade: 'B', count: 80 },
        { grade: 'C', count: 100 },
        { grade: 'D', count: 40 },
        { grade: 'F', count: 20 }
    ];

    const admissionBatchData: AdmissionBatchData[] = [
        { batch: '2021-2022', studentCount: 350 },
        { batch: '2022-2023', studentCount: 400 },
        { batch: '2023-2024', studentCount: 450 }
    ];

    const semesterData: SemesterData[] = [
        { semester: 'Học kỳ 1, 2022-2023', averageGrade: 7.5 },
        { semester: 'Học kỳ 2, 2022-2023', averageGrade: 7.8 },
        { semester: 'Học kỳ 1, 2023-2024', averageGrade: 8.0 }
    ];

    return (
        <Page>
            {/* <ProcessModal process_id='x'/> */}
            <Box sx={{ height: '100%' }}>
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Biểu Đồ Đăng Ký Sinh Viên
                                </Typography>
                                <BieuDoDangKy data={registrationData} />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Biểu Đồ Phân Phối Điểm
                                </Typography>
                                <BieuDoPhanPhoiDiem data={gradeDistributionData} />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Số Lượng Sinh Viên Theo Đợt Tuyển Sinh
                                </Typography>
                                <BieuDoTuyenSinh data={admissionBatchData} />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6" gutterBottom>
                                    Điểm Trung Bình Theo Học Kỳ
                                </Typography>
                                <BieuDoHocKy data={semesterData} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Page>
    );
};

export default HomePage;
